export const formatAmountInDollars = (value: number): string => {
  if (isNaN(value)) {
    return "$0";
  }

  const formattedValue = Math.round(value / 100);
  return `$${formattedValue.toLocaleString("en-US")}`;
};
